import { routeCurrent } from '@iez/core/router'
import { inject } from '@vue/composition-api'

export default ({ name, payload, shouldReset }={}) =>
  inject(`setup${name || routeCurrent.name}`)(payload, shouldReset)
